import EducationForm from "./EducationForm";

export default EducationForm;
